module.exports = __webpack_public_path__ + "img/thumbnail_SnowLeopard_m_normal.1c85c1b4.png";